import api from "../utils/api";

export const getAllAccounts = async ({ phone }: { phone: string }) => {
  return await api.req({
    url: `/clients/by-user-phone/${phone}`,
    method: api.Method.GET,
  });
};

export const getAllAccountsByEmail = async ({ email }: { email: string }) => {
  return await api.req({
    url: `/clients/by-user-email/${email}`,
    method: api.Method.GET,
  });
};

